LS.util.route({
	'account': {
		'$guard:eval': {
			'profile': {
				'$index': {
					':load': 'account.profile',
					':unload': 'account.profile:unload'
				}
			},
			'profiles': {
				'$num': {
					'$index': {
						':load': 'account.profile',
						':unload': 'account.profile:unload'
					},
					'preview': {
						':load': 'account.profile.preview',
						':unload': 'account.profile.preview:unload'
					}
				}
			}
		}
	}
});